<template>
    <BaseMapShell v-model:panelOpen="panelOpen" :center="center" :zoom="zoom" :bounds="bounds" :max-bounds="maxBounds"
        :minZoom="3" :maxZoom="19">
        <!-- Toolbar droite : datepicker -->
        <template #toolbar-right>
            <MapDatepicker :date="date" @updateDate="pickedDate = $event" />
        </template>

        <!-- Calques spécifiques -->
        <template v-if="positions && positions.length">
            <SpeedLegend />
            <AlarmMarker v-for="alarm in alarms" :key="alarm.id" :alarm="alarm" />
            <SpeedPolylineLayer :polyline-data="polylineData" />
        </template>
    </BaseMapShell>
</template>

<script>
import BaseMapShell from "../BaseMapShell.vue";
import AlarmMarker from "../Components/AlarmMarker.vue";
import PositionService from '@/services/position.service.js'
import AlarmService from '@/services/alarm.service.js'
import FormatHelper from '@/helpers/format.helper.js'
import SpeedLegend from "../Components/SpeedLegend.vue";
import MapDatepicker from "../Components/MapDatepicker.vue";
import SpeedPolylineLayer from "../Components/SpeedPolylineLayer.vue";
import { getPolylineDataFromPositions } from "../composables/usePolyline";
import { computePaddedBounds } from "../composables/useBounds";
import { normalizePositions } from "../composables/usePositions";

export default {
    props: ['date'],
    components: {
        BaseMapShell,
        AlarmMarker,
        SpeedLegend,
        MapDatepicker,
        SpeedPolylineLayer
    },
    data() {
        return {
            panelOpen: false,
            zoom: 13,
            center: [48.9571487, 2.1941876],
            bounds: [],
            maxBounds: [],
            positions: [],
            alarms: [],
            pickedDate: this.date,
            polylineData: {},
        };
    },
    mounted() {
        this.getPositions();
        this.getAlarms();
    },
    watch: {
        pickedDate: function () {
            this.getPositions();
            this.getAlarms();
        },
    },
    methods: {
        getPositions() {
            PositionService.getBalisePositions(this.$route.params.baliseId, 0, 6000, FormatHelper.dateFormatUTC(this.pickedDate), FormatHelper.dateFormatUTC(this.pickedDate, true))
                .then(response => {
                    const raw = FormatHelper.balisePingsFormat(response.data.filter(Array));
                    this.positions = normalizePositions(raw);
                    // bounds robustes (>= 2 points) sinon centre/zoom
                    this.$nextTick(() => {
                        if (this.positions.length >= 2) {
                            this.bounds = computePaddedBounds(this.positions);
                        } else if (this.positions.length === 1) {
                            this.bounds = [];
                            this.center = [this.positions[0].latitude, this.positions[0].longitude];
                            this.zoom = 15;
                        } else {
                            this.bounds = [];
                        }
                    });
                    this.polylineData = getPolylineDataFromPositions(this.positions);
                })
        },
        getAlarms() {
            AlarmService.getBaliseAlarms(this.$route.params.baliseId, 0, 500, FormatHelper.dateFormatUTC(this.pickedDate), FormatHelper.dateFormatUTC(this.pickedDate, true))
                .then(response => {
                    this.alarms = FormatHelper.baliseAlertsFormat(response.data.rows);
                })
        },
    }
}
</script>